import { useEffect } from 'react';

// Declaração de tipos para o Hotjar
declare global {
  interface Window {
    hj: (command: string, ...args: any[]) => void;
  }
}

export const useHotjarWidget = (shouldShow: boolean = true) => {
  useEffect(() => {
    // Se não deve mostrar o Hotjar, retorna sem configurar
    if (!shouldShow) {
      return;
    }

    // Aguarda o Hotjar carregar e configura para mostrar o widget automático
    const configureHotjar = () => {
      if (typeof window !== 'undefined' && window.hj) {
        // Configura o Hotjar para mostrar o widget de feedback automaticamente
        window.hj('config', {
          // Habilita o feedback
          feedback: true,
          // Desabilita outras funcionalidades para focar apenas no feedback
          heatmaps: false,
          recordings: false
        });

        console.log('Hotjar configurado para widget de feedback automático');
      } else {
        // Se o Hotjar ainda não carregou, tenta novamente em 1 segundo
        setTimeout(configureHotjar, 1000);
      }
    };

    // Inicia a configuração
    configureHotjar();
  }, [shouldShow]);
};

export default useHotjarWidget;
